import httpClient, { IRequest, IResponse } from '../../../apiService/httpClient';
import { IGetUserEmailResponse, IGetUserNameResponse } from '../IApiResponse';

const BeMaccaferriIdentityProvider = () => {
    const _baseURL = process.env.REACT_APP_IDENTITY_BASE_URL as string;

    const _createRequest = <D>(_pathname: string, _queryString?: string, _data?: D): IRequest => {
        return {
            url: _queryString ? _pathname + '?' + _queryString : _pathname,
            baseURL: _baseURL,
            data: _data,
        };
    };

    const getUserNameAsync = async (): Promise<IResponse<IGetUserNameResponse>> => httpClient.getAsync(_createRequest('v1/macroidentity/current-user-name'));

    const getUserEmailAsync = async (): Promise<IResponse<IGetUserEmailResponse>> => httpClient.getAsync(_createRequest('v1/macroidentity/current-user-email'));

    const logoutAsync = async (): Promise<IResponse<boolean>> => httpClient.getAsync(_createRequest('v1/macroidentity/logout'));

    return {
        getUserNameAsync,
        getUserEmailAsync,
        logoutAsync,
    };
};
export default BeMaccaferriIdentityProvider();
